module.exports = __webpack_public_path__ + "img/icon-logout.ac4bf779.svg";